import invariant from 'tiny-invariant'

import useUser from './useUser'

export const useAuthenticatedUser = () => {
  const { user, ...rest } = useUser()

  invariant(user !== null, 'Authenticated user required')

  return {
    user,
    ...rest,
  }
}
